import _ from 'lodash';
import moment from "moment";
import React from "react";
import { t } from "../helpers/translator";
import Config from "../../dev/config/conf";
import { store } from '../index/terminalApp';
import { getNetworkTime } from './networkTime';

var Helpers = (function () {
    return {
        /*
         mergeSort: (function () {
         "use strict";
         /!**
         * Sorts an array of integers using the MergeSort algorithm.
         * @param {Array.<number>} items Array of items to be sorted.
         *!/

         /!*
         var merge = function(left, right) {
         var result = [];

         while (left.length || right.length) {
         result.push(
         left.length && left[0] <= (right[0] || Number.MAX_VALUE) ?
         left.shift() :
         right.shift());
         }

         return result;
         };

         var sort = function(arr) {
         var middle = arr && (arr.length / 2) << 0;

         if (!middle) {
         return arr;
         } else if (arr.length === 2) {
         return arr[1] < arr[0] ? arr.reverse() : arr;
         }

         return merge(sort(arr.slice(0, middle)), sort(arr.slice(middle)));
         };*!/

         function merge (left, right) {
         var result = [];
         while (left.length > 0 && right.length > 0) {
         if (left[0] < right[0]) {
         result.push(left.shift());
         } else {
         result.push(right.shift());
         }
         }
         return result.concat(left).concat(right);
         }

         function sort (arr) {
         if (arr.length <= 1) {
         return arr;
         }
         var middle = Math.floor(arr.length / 2);
         var left = arr.slice(0, middle);
         var right = arr.slice(middle);
         return merge(sort(left), sort(right));
         }

         return function (items) { return sort(items); };
         })(),
         */

        MakeLetterCapitalize: function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        /**
         * Check is split screen available
         * @returns {boolean} Available or not
         */

        isSplitScreenAvailable: function () {
            return window.innerWidth < window.innerHeight && Config.splitScreen && Config.splitScreenUrl;
        },

        /**
         * Validate CNP
         * @param   {string}  value CNP
         * @returns {boolean} Valid or not
         */
        validateCNP: function (value) {
            var i = 0, year = 0, hashResult = 0, cnp = [], hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            if (value.length !== 13) { return false; }
            for (i = 0; i < 13; i++) {
                cnp[i] = parseInt(value.charAt(i), 10);
                if (isNaN(cnp[i])) { return false; }
                if (i < 12) { hashResult = hashResult + (cnp[i] * hashTable[i]); }
            }
            hashResult = hashResult % 11;
            if (hashResult === 10) { hashResult = 1; }
            year = (cnp[1] * 10) + cnp[2];
            switch (cnp[0]) {
                case 1: case 2: year += 1900; break;
                case 3: case 4: year += 1800; break;
                case 5: case 6: year += 2000; break;
                case 7: case 8: case 9:
                    year += 2000;
                    if (year > (parseInt(new Date().getYear(), 10) - 14)) {
                        year -= 100;
                    }
                    break;
                default: return false;
            }
            if (year < 1800 || year > 2099) { return false; }
            return (cnp[12] === hashResult);
        },

        /**
 * isCNP18plus CNP
 * @param   {string}  value CNP
 * @returns {boolean} Valid or not
 */

        isCNP18plus: function (value) {
            var i = 0, year = 0, month = 0, day = 0, hashResult = 0, cnp = [], hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            if (value.length !== 13) { return false; }
            for (i = 0; i < 13; i++) {
                cnp[i] = parseInt(value.charAt(i), 10);
                if (isNaN(cnp[i])) { return false; }
                if (i < 12) { hashResult = hashResult + (cnp[i] * hashTable[i]); }
            }
            hashResult = hashResult % 11;
            if (hashResult === 10) { hashResult = 1; }
            year = (cnp[1] * 10) + cnp[2];
            month = (cnp[3] * 10) + cnp[4];
            day = (cnp[5] * 10) + cnp[6];

            switch (cnp[0]) {
                case 1: case 2: year += 1900; break;
                case 3: case 4: year += 1800; break;
                case 5: case 6: year += 2000; break;
                case 7: case 8: case 9:
                    year += 2000;
                    if (year > (parseInt(new Date().getYear(), 10) - 14)) {
                        year -= 100;
                    }
                    break;
                default: return false;
            }

            let adulDateBirth = new Date();
            let dateOfPerson = new Date(year, month - 1, day);
            adulDateBirth.setFullYear(adulDateBirth.getFullYear() - 18);

            if (dateOfPerson <= adulDateBirth) {
                return true;
            } else {
                return false;
            }
        },

        isArraysEqual: function (array1, array2) {
            // if the other array is a falsy value, return // compare lengths - can save a lot of time
            if (!array1 || !array2 || array1.length !== array2.length) {
                return false;
            }

            for (let i = 0, l = array1.length; i < l; i++) {
                // Check if we have nested arrays
                if (array1[i] instanceof Array && array2[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!Helpers.isArraysEqual(array1[i], array2[i])) {
                        return false;
                    }
                } else if (array1[i] !== array2[i]) {
                    // Warning - two different object instances will never be equal
                    return false;
                }
            }
            return true;
        },

        /**
         * @name getWeightedRandom
         * @description returns "weighted" random element of array
         * @param {Array} array the array
         * @param {String} weightFieldName array's objects' field name that contains it's weight
         *
         * @return {Object} random weighted array item
         */
        getWeightedRandom: function getWeightedRandom(array, weightFieldName = 'weight') {
            var variants = [], i;
            array.forEach(function (item) {
                if (item.ignore) {
                    return;
                }
                for (i = 0; i < (item[weightFieldName] || 1); i++) {
                    variants.push(item);
                }
            });

            var index = Math.floor(Math.random() * variants.length);

            return variants[index];
        },

        cloneDeep: function (data) {
            return JSON.parse(JSON.stringify(data));
        },

        byOrderSortingFunc: function byOrderSortingFunc(a, b) {
            if (a.order < 0) return 1;
            else if (b.order < 0) return -1;

            return a.order - b.order;
        },
        /**
         * @name byOrderSortingFunc
         * @description Function that merges Markets and deletes elements that appear more than once
         * @param sportAliasArr {Array}
         * @param marketArr {Array}
         * @param gameType {String}
         * @returns {number}
         */
        asianViewMarketMerge: function asianViewMarketMerge(sportAliasArr, marketArr, gameType) {
            let marketsArray = [];
            const gameTypeA = gameType === 'live' ? gameType : 'prematch';
            sportAliasArr.map((item) => marketArr[item] && marketArr[item][gameTypeA] && marketArr[item][gameTypeA].map((marketContainer) => {
                marketContainer.forEach(element => {
                    // eslint-disable-next-line no-unused-vars
                    const { title, side, base, ...rest } = element;
                    if (base !== undefined && base !== 'all') {
                        marketsArray.push({ ...rest, base });
                    } else {
                        marketsArray.push(rest);
                    }
                });
            }));
            return marketsArray;
        },
        /**
         * @name orderByPrice
         * @description Function to be used by sort(), to sort by object's "price" property
         * @param a {Object}
         * @param b {Object}
         * @returns {number}
         */
        orderByPrice: function orderByPrice(a, b) {
            return a.price - b.price;
        },


        getWithOrdinalSuffix: function(num) {
            const j = num % 10;
            const k = num % 100;

            if (j == 1 && k != 11) return num + "st";
            if (j == 2 && k != 12) return num + "nd";
            if (j == 3 && k != 13) return num + "rd";

            return num + "th";
        },

        /**
         * @name Helpers.calculateTaxForReturnedAndProfit
         * @description returns game object from config
         * @param {Number} present
         * @param {Number} amount
         * @return {Number} returns game object from config
         */
        calculateTaxForReturnedAndProfit: function calculateTaxForReturnedAndProfit(present, amount, taxRange) {
            var rangeList;
            var result = 0;
            if (taxRange) {
                rangeList = taxRange;
                for (let item of rangeList) {
                    const { from, to, entire_amount, percent: presentItem } = item;
                    if (entire_amount) {
                        if (from <= amount && to > amount) {
                            result = amount * presentItem / 100;
                            break;
                        }
                    } else if (from < amount && presentItem > 0 && presentItem < 100) {
                        if (amount <= to) {
                            result += (amount - from) * presentItem / 100;
                            break;
                        } else {
                            result += (to - from) * presentItem / 100;
                        }
                    }
                }
            } else {
                rangeList = (Config.main.taxRange || [{ range: [0, 100000000000000], present }]).sort(({ range: [fromA] }, { range: [fromB] }) => fromA - fromB);
                for (let item of rangeList) {
                    const { range: [fromAmount, toAmount], present: presentItem } = item;
                    if (fromAmount < amount && presentItem > 0 && presentItem < 100) {
                        if (amount <= toAmount) {
                            result += (amount - fromAmount) * presentItem / 100;
                            break;
                        } else {
                            result += (toAmount - fromAmount) * presentItem / 100;
                        }
                    }
                }
            }
            return result || 0;
        },
        /**
        * @name Helpers.calculateTaxForReturnedAndProfit
        * @description returns bet possible tax amount or null
        * @param {Number} possWin
        * @param {Number} stake
        * @return {Number} possible tax amount
        */
        calculatePossibleTaxAmount: function (possWin, stake) {
            const partnerTax = store.getState().swarmConfigData.partner;
            if (possWin && partnerTax.tax_type && (partnerTax.tax_percent || partnerTax.tax_percent === 0) && (partnerTax.tax_integration_type === 0 || partnerTax.tax_integration_type === 2)) {
                const amount = partnerTax.tax_type === 1 ? possWin - stake : possWin;
                return Helpers.calculateTaxForReturnedAndProfit(partnerTax.tax_percent, amount, partnerTax.tax_amount_ranges || null);
            }

            return null;
        },
        /**
         * @name orderByBase
         * @description Function to be used by sort(), to sort by object's "price" property
         * @param a {Object}
         * @param b {Object}
         * @returns {number}
         */
        orderByBase: function orderByBase(b, a) {
            return b.base - a.base;
        },
        /**
         * @name getHash
         * @description function to generate arrayBuffer(32)
         * @param privateKey  {string}
         * @returns {ArrayBuffer(32)}
         */
        getHash: async function (privateKey) {
            const networkTime = await getNetworkTime();
            let seconds = Math.floor(networkTime / 1000);
            let ts = Math.floor(seconds / 30);
            let message = `_${ts}-${privateKey}`;
            const msgUint8 = new TextEncoder().encode(message);
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            return hashHex;
        },
        /**
         * @name orderByName
         * @description Function to be used by sort(), to sort by object's "name" property
         * @param a {Object}
         * @param b {Object}
         * @returns {number}
         */
        orderByName: function orderByName(a, b) {
            let nameA = t(a.name),
                nameB = t(b.name);
            if (nameA > nameB) {
                return 1;
            } else if (nameA < nameB) {
                return -1;
            }
            return 0;
        },
        /**
         * @name byStartTsSortingFunc
         * @description Function to be used by sort(), to sort by object's "start_ts" property
         * @param a {Object}
         * @param b {Object}
         * @returns {number}
         */
        byStartTsSortingFunc: function byStartTsSortingFunc(a, b) {
            if (a.start_ts === b.start_ts) {
                return a.id - b.id;
            }
            return a.start_ts - b.start_ts;
        },
        /**
         * @name byStartTsWithEqualSortingFunc
         * @description Function to be used by sort(), to sort by object's "start_ts" property
         * and will use createdEqualSortingFn sorting function when "start_ts" properties are equal
         * @param createdEqualSortingFn {function}
         * @returns {function}
         */
        byStartTsWithEqualSortingFunc: function (createdEqualSortingFn) {
            return (a, b) => {
                if (a.start_ts === b.start_ts && createdEqualSortingFn) {
                    return createdEqualSortingFn(a, b);
                }
                return a.start_ts - b.start_ts;
            };
        },
        /**
         * @name createSortingFn
         * @description Creates sorting fynction to sort by provided field name
         * @param {String} field field name
         * @param {Boolean} ascending true to sort ascending, false for descending
         * @returns {function}
         */
        createSortingFn: function (field, ascending = true) {
            return (a, b) => (ascending ? (a[field] - b[field]) : (b[field] - a[field]));
        },
        /**
         * @name objectToArray
         * @description Converts object to array
         * @param {Object} obj
         * @param {String} addKeyNameAsProperty if defined, object key names will be added to array elements with property of this name
         * @param {function} calculator if defined, callback will called for each item and will passed whole object for calculating purpose
         * @returns {Array}
         */
        objectToArray: function objectToArray(obj, addKeyNameAsProperty = null, calculator = null) {
            var arr = [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (addKeyNameAsProperty) {
                        obj[key][addKeyNameAsProperty] = key;
                    }
                    calculator && calculator(obj[key]);
                    arr.push(obj[key]);
                }
            }
            return arr;
        },

        /**
         * @name invertObject
         * @description Inverts object keys and values
         * @param {Object} obj
         * @returns {Object}
         */
        invertObject: function invertObject(obj) {
            const result = {};

            for (const key in obj) {
                const value = obj[key];
                if (!obj[value]) result[value] = key;
                else {
                    // If [value] key exists inside the object keep the value
                    result[value] = obj[value];
                }
            }

            return result;
        },

        /**
         * @name firstElement
         * @description Returns first element of an object
         * @param {Object} obj
         * @param {boolean|function} sortFunc function to sort object keys (false for no sorting). if not provided, will be sorted by
         * @returns {*}
         */
        firstElement: function firstElement(obj, sortFunc = null, key = null) {
            if (typeof obj !== "object") {
                return null;
            }
            var keys = Object.keys(obj);
            if (!keys.length) {
                return null;
            }
            if (sortFunc === false) {
                return obj[keys[0]];
            }
            sortFunc = sortFunc || this.byOrderSortingFunc;
            return this.objectToArray(obj, key).sort(sortFunc)[0];
        },
        /**
         * @ngdoc method
         * @name MergeRecursive
         * @methodOf vbet5.service:Utils
         * @description merges 2 objects recursively
         * @param {Object} to destination object
         * @param {Object} from source object
         * @return {Object} returns changed destination object
         */
        mergeRecursive: function mergeRecursive(to, from) {
            var p;
            for (p in from) {
                if (from.hasOwnProperty(p)) {
                    try {
                        if (from[p].constructor === Object) {
                            if (from[p]['@replace'] === true) {  //replace field instead of merging if specified
                                to[p] = from[p];
                                delete to[p]['@replace'];
                            } else {
                                to[p] = mergeRecursive(to[p], from[p]);
                            }
                        } else {
                            to[p] = from[p];
                        }
                    } catch (e) {
                        to[p] = from[p];
                    }
                }
            }
            return to;
        },

        /**
         * @name getArrayObjectElementHavingFieldValue
         * @description  returns array element object having field with specified value
         * @param {Array} array array of objects
         * @param {String} field the field name
         * @param {Object|String|Number} value field value
         * @return {Object|null}  object or null if not found
         */
        getArrayObjectElementHavingFieldValue: function getArrayObjectElementHavingFieldValue(array, field, value) {
            var i;
            for (i = 0; i < array.length; i++) {
                if (array[i][field] === value) {
                    return array[i];
                }
            }
            return null;
        },
        /**
         * @name nl2br
         * @description converts newlines to <br> in given string
         * @param {String} str string to convert
         *
         * @return {String} string with <br>s instead of new lines
         */
        nl2br: function nl2br(str) {
            return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
        },

        /**
         * @name isNumeric
         * @description Checks if argument is numeric
         * @param {*} n
         * @returns {boolean}
         */
        isNumeric: function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        /**
         * @name isEqual
         * @description Checks if argument is numeric
         * @param {object} obj1
         * @param {object} obj2
         * @returns {boolean}
         */
        isEqual: function isEqual(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        },
        /**
         * @name isAndroid
         * @description Checks if operating system of device is android
         * @returns {boolean}
         */
        isAndroid: function () {
            return Helpers.getMobileOperatingSystem() === 'android';
        },
        /**
         * @name isIos
         * @description Checks if operating system of device is ios
         * @returns {boolean}
         */
        isIos: function () {
            return Helpers.getMobileOperatingSystem() === 'iphone';
        },
        /**
         * @name windows phone
         * @description Checks if operating system of device is windows phone
         * @returns {boolean}
         */
        isWindowsPhone: function () {
            return Helpers.getMobileOperatingSystem() === 'windows';
        },
        /**
         * @name isPC
         * @description Checks if operating system of device is PC
         * @returns {boolean}
         */
        isPC: function () {
            return !Helpers.isIos() && !Helpers.isAndroid() && !Helpers.isWindowsPhone() && window.innerWidth >= 980;
        },
        /**
         * @name tabletViewActive
         * @description Checks if is Tablet Version, only our project
         * @returns {boolean}
         */
        tabletViewActive: function () {
            // let orientation = screen.orientation || screen.mozOrientation || screen.msOrientation, orientationAngle = (orientation && orientation.angle) || window.orientation;
            return screen.width >= 980 || screen.height >= 980; //@TODO change
        },
        /**
         * @name isChrome
         * @description Checks if browser type is Chrome
         * @returns {boolean}
         */
        isChrome: function () {
            return Helpers.getBrowserType() === 'chrome';
        },
        /**
         * @name isSafari
         * @description Checks if browser type is Safari
         * @returns {boolean}
         */
        isSafari: function () {
            return Helpers.getBrowserType() === 'safari';
        },
        /**
         * @name isFirefox
         * @description Checks if browser type is Firefox
         * @returns {boolean}
         */
        isFirefox: function () {
            return Helpers.getBrowserType() === 'firefox';
        },
        /**
         * @name isIE
         * @description Checks if browser type is IE
         * @returns {boolean}
         */
        isIE: function () {
            return Helpers.getBrowserType() === 'IE';
        },
        /**
         * @name isOpera
         * @description Checks if browser type is Opera
         * @returns {boolean}
         */
        isOpera: function () {
            return Helpers.getBrowserType() === 'opera';
        },
        /**
         * @name getMobileOperatingSystem
         * @description Returns device operation system name or unknown
         * @returns {string}
         */
        getMobileOperatingSystem: function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "windows";
            }

            if (/android/i.test(userAgent)) {
                return "android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iphone";
            }

            return "unknown";
        },

        getBrowserType: function getBrowserType() {
            // switch (true) {
            //     case !!window.chrome && !!window.chrome.webstore:
            //         return 'chrome';
            //     case /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || window.safari.pushNotification):
            //         return 'safari';
            //     case typeof InstallTrigger !== 'undefined':
            //         return 'firefox';
            //     case false || !!window.document.documentMode:
            //         return 'IE';
            //     case (Object.prototype.toString.call(window.operamini) === "[object OperaMini]"):
            //         return 'opera';
            //     default:
            //         return false;
            // }
            return false;
        },
        getTransactionType: function () {
            let { pathname } = window.location;
            switch (true) {
                case pathname.includes('balance/deposit'):
                    return 'deposit';
                case pathname.includes('balance/withdraw'):
                    return 'withdraw';
                default:
                    return '';
            }
        },
        /**
         * @name setClassNameOnBody
         * @description set class on body if some parts of UI are opened
         * @param {Object} openedUIObj, UI opened object
         * @returns {Boolean}
         */
        setClassOnBodyUI: function (openedUIObj) {
            let availableClassNames = ["betslip", "leftMenu", "rightMenu"];
            for (let i in openedUIObj) {
                if (openedUIObj[i] && availableClassNames.includes(i)) {
                    return true;
                }
            }
            return false;
        },
        /**
         * @name addClassName
         * @description It should add class name on the element
         * @param {string} selectors
         * @param {string} setClassName
         */
        addClassName: function (selectors, setClassName) {
            let element = document.querySelectorAll(selectors)[0];
            if (element && !element.className.includes(setClassName)) {
                element.classList.add(setClassName);
            }
        },
        /**
         * @name removeClassName
         * @description It should remove class name on the element
         * @param {string} selectors
         * @param {string} setClassName
         */
        removeClassName: function (selectors, setClassName) {
            let element = document.querySelectorAll(selectors)[0];
            if (element && setClassName && element.className.includes(setClassName)) {
                element.classList.remove(setClassName);
            }
        },
        /**
         * @name toggleClassName
         * @description It should toggle class name on the element
         * @param {string} selectors
         * @param {string} setClassName
         */
        toggleClassName: function (selectors, setClassName) {
            let element = document.querySelectorAll(selectors)[0];
            element.classList.toggle(setClassName);
        },
        /**
         * @name replaceClassName
         * @description It should check class name on the element
         * @param {string} selectors
         * @param {string} prevPath
         * @param {string} currentPath
         */
        replaceClassName: function (selectors, prevPath, currentPath) {
            if (prevPath !== currentPath) {
                Helpers.removeClassName(selectors, prevPath);
                Helpers.addClassName(selectors, currentPath);
            }
        },
        /**
         * @name existClassName
         * @description It should check class name on the element
         * @param {string} selectors
         * @param {string} setClassName
         */
        existClassName: function (selectors, setClassName) {
            let element = document.querySelectorAll(selectors)[0];
            return !!((element && element.className) && element.className.includes(setClassName));
        },
        /**
         * @name getElementBySelector
         * @param selector
         * @param props
         * @returns {*}
         */
        getElementBySelector: function (selector, props) {
            let element = document.querySelector(selector);

            if (!(element && props)) return element;

            return props.map(prop => element[prop]);
        },
        /**
         * @name getHashParams
         * @description Returns location hash params
         * @returns {{}}
         */
        getHashParams: function getHashParams() {
            var hashParams = {};
            var e,
                a = /\+/g,  // Regex for replacing addition symbol with a space
                r = /([^?/&;=]+)=?([^&;]*)/g,
                d = function (s) {
                    return decodeURIComponent(s.replace(a, " "));
                },
                q = window.location.hash.substring(1);
            while (e = r.exec(q)) {
                hashParams[d(e[1])] = d(e[2]);
            }
            return hashParams;
        },
        /**
         * @name getQueryStringValue
         * @description Returns location query param
         * @param {String} name of the param
         * @param {String} url to get the param form given string default is current location
         * @returns {String}
         */
        getQueryStringValue: function (name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },
        /**
         * @name getUriParam
         * @description Returns hash or query param from location
         * @param {string} key
         * @returns {*}
         */
        getUriParam: function (key) {
            return Helpers.getQueryStringValue(key, null) || (Helpers.getHashParams() || {})[key];
        },
        /**
         * @name GetObjectByStringPath
         * @description Returns part of the object o identified by path s
         * @param {Object} o source object
         * @param {String} s path (e.g. "data.messages")
         * @returns {*}
         */
        GetObjectByStringPath: function GetObjectByStringPath(o, s) {
            s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
            s = s.replace(/^\./, '');           // strip a leading dot
            var a = s.split('.');
            for (var i = 0, n = a.length; i < n; ++i) {
                var k = a[i];
                if (k in o) {
                    o = o[k];
                } else {
                    return;
                }
            }
            return o;
        },
        /**
         * @name CheckIfPathExists
         * @description Returns part of the object o identified by path s
         * @param {Object} o source object
         * @param {String} path (e.g. "data.messages")
         * @returns {boolean}
         */
        CheckIfPathExists(o, path) {
            try {
                return Boolean(Helpers.GetObjectByStringPath(o, path));
            } catch (e) {
                return false;
            }
        },
        /**
         * @name AssignValueToPropName
         * @description recursive assigning values to object from string path
         * @param {object} obj
         * @param {*} prop
         * @param {*} value
         */
        AssignValueToPropName: function (obj, prop, value) {
            if (typeof prop === "string") {
                prop = prop.split(".");
            }
            if (prop.length > 1) {
                let e = prop.shift();
                this.AssignValueToPropName(obj[e] =
                    Object.prototype.toString.call(obj[e]) === "[object Object]"
                        ? obj[e]
                        : {}, prop, value);
            } else {
                obj[prop[0]] = value;
            }
        },
        /**
         * @name generateQueryParamsFromObject
         * @description Returns uri encoded url
         * @param {object} obj
         * @param {string} url
         * @param {string} separator
         * @param {string} switchQueryToHash
         * @returns {string}
         */
        generateQueryParamsFromObject(obj, url = "", separator, switchQueryToHash) {
            return Object.keys(obj).reduce((str, key) => {
                if (str !== "") {
                    str += str.indexOf(switchQueryToHash || "?") === -1 ? switchQueryToHash || '?' : separator || "&";
                }
                str += key + "=" + encodeURIComponent(obj[key]);
                return str;
            }, url);
        },
        /**
         * @name removeMatchingPartFromObject
         * @description Removes object defined by path, field name and value from the object
         * @param {Object} obj the source object
         * @param {String} path string path to iterable object inside obj (e.g. "data.messages.messages")
         * @param {String} field field name
         * @param {*} value field value to match
         */
        removeMatchingPartFromObject: function removeMatchingPartFromObject(obj, path, field, value) {
            let container = this.GetObjectByStringPath(obj, path);
            if (Array.isArray(container)) {
                let index = container.reduce((acc, curr, ind) => (curr[field] === value ? ind : acc), null);
                (index !== null) && container.splice(index, 1);
            } else if (typeof container === "object") {
                let key = Object.keys(container).reduce((acc, curr) => (container[curr][field] === value ? curr : acc), null);
                (key !== null) && delete container[key];
            }
        },

        /**
         * @name checkStatus
         * @description helper function to check request status and throw exception when something is wrong
         * @param {Object} response
         * @returns {Object | Undefined}
         */
        checkStatus: function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                let error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        },

        /**
         * @name convertBalance
         * @description helper function remove numbers ,if after dot numbers lenght > 2
         * @param {number} value
         * @returns {number}
         */
        convertBalance: function (value) {
            value = Math.floor(value * 100) / 100;
            return value;
        },
        /**
         * @name disableDefaultScroll
         * @description disable Default Scroll
         * @param {DOM element} scrolledElement
         * @param {boolean} enableListeners
         */

        disableDefaultScroll: function (scrolledElement, enableListeners = true) {
            let handleScrollEvent = event => {
                if (scrolledElement.scrollTop === (scrolledElement.scrollHeight - scrolledElement.clientHeight)) {
                    scrolledElement.scrollTop = scrolledElement.scrollHeight - scrolledElement.clientHeight - 1;
                }
                if (scrolledElement.scrollTop === 0) {
                    scrolledElement.scrollTop = 1;
                }
                scrolledElement.allowUp = (scrolledElement.scrollTop > 0);
                scrolledElement.allowDown = (scrolledElement.scrollTop < (scrolledElement.scrollHeight - scrolledElement.clientHeight));
                scrolledElement.lastY = event.pageY;

                let up = (event.pageY > scrolledElement.lastY), down = !up;
                scrolledElement.lastY = event.pageY;
                if ((up && scrolledElement.allowUp) || (down && scrolledElement.allowDown)) {
                    event.stopPropagation();
                } else {
                    event.preventDefault();
                }
            }, handleTouchMoveEvent = event => {
                if (scrolledElement.clientHeight === scrolledElement.scrollHeight) {
                    event.preventDefault();
                }
            };

            if (scrolledElement) {
                if (!enableListeners) {
                    scrolledElement.removeEventListener('touchmove', handleTouchMoveEvent);
                    scrolledElement.removeEventListener('scroll', handleScrollEvent);
                } else {
                    scrolledElement.addEventListener('touchmove', handleTouchMoveEvent);
                    scrolledElement.addEventListener('scroll', handleScrollEvent);
                }
            }
        },
        getRouteType: function (pathname) {
            return {
                "casino": "casino",
                "live-casino": "casino",
                "games": "casino",
                "free-quiz": "casino",
                "game": "sport",
                "live": "sport",
                "prematch": "sport",
                "poker": "zharmar",
                "asian_prematch": "sport",
                "asian_live": "sport",
                "asian_today": "sport",
                "": "home"
            }[pathname.split("/")[1]];
        },
        /**
         * @name amountNormalizer
         * @description Helper function for validation
         * @param {number|string} value
         * @returns {number|string}
         */
        amountNormalizer: (value, oldValue) => {
            if (value && ("" + value).length > 1 && ("" + value).match(/^0/) && ("" + value).indexOf(".") !== 1) {
                value = value.split("");
                value = value[1];
            }
            return isNaN(value) ? oldValue : value || "";

        },
        placeNumber: function (number) {
            switch (number) {
                case 1: return '1st';
                case 2: return '2nd';
                case 3: return '3rd';
                default: return number + 'th';
            }
        },
        convertDateToUTC: function (date, format = "YYYY.MM.DD HH:mm") {
            return moment.utc(date).local().format(format);
        },
        hideLeftMenuForSpecificRoutes: function (pathname) {
            let routes = [
                "/promotions",
                "/free-quiz",
                "/poker",
                "/casino/tournaments"
            ];
            return routes.includes(pathname);
        },
        disableKeyCode: function (event, keyCodes) {
            let charCode = event.which || event.keyCode;
            return keyCodes.includes(charCode) && event.preventDefault();
        },
        addPageDots: function (itemsCount, itemsPerPage, currPage) {
            let dots = [];
            let count = itemsCount && Math.ceil(itemsCount / itemsPerPage);
            for (let i = 0; i < count; i++) {
                if (i === currPage - 1) {
                    dots.push(<span key={i} />);
                } else {
                    dots.push(<span className="active" key={i} />);
                }
            }
            return dots;
        },
        moveElementArrayFirstIndex: function (arr, oldIndex, newIndex) {
            if (newIndex !== -1) {
                while (oldIndex < 0) {
                    oldIndex += arr.length;
                }
                while (newIndex < 0) {
                    newIndex += arr.length;
                }
                if (newIndex >= arr.length) {
                    let k = newIndex - arr.length;
                    while ((k--) + 1) {
                        arr.push(undefined);
                    }
                }
                arr.splice(oldIndex, 0, arr.splice(newIndex, 1)[0]);
            }
            return arr;
        },
        hasClassName: function (selector, currentClassName) {
            let element = document.querySelectorAll(selector)[0];
            return [...element.classList].indexOf(currentClassName) > 0;
        },
        hasLiveGame: function (events = []) {
            return (events.length && events.some(event => event.gameType === 1));
        }
    };

})();

export const dynamicPrice = (price, currencyId, dotted = true) => {
    const amount = dotted ? price.toLocaleString() : price;

    if (Config.useCurrencySymbol && Config.main.currency[currencyId])
        return `${Config.main.currency[currencyId]}${amount}`;

    return `${amount} ${currencyId}`;
};

export const normalizeISO = isoString => {
    if (isoString.endsWith('Z')) return isoString;
    return `${isoString}Z`;
}

export default Helpers;